module.exports = "/images/sort-solid.svg?d934cf246ecae19ec46a93fe34d0829e";


//////////////////
// WEBPACK FOOTER
// ./public/icons/sort-solid.svg
// module id = C+P4
// module chunks = 0